import { render, staticRenderFns } from "./AssetTransferList.vue?vue&type=template&id=760a141f"
import script from "./AssetTransferList.vue?vue&type=script&lang=js"
export * from "./AssetTransferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('760a141f')) {
      api.createRecord('760a141f', component.options)
    } else {
      api.reload('760a141f', component.options)
    }
    module.hot.accept("./AssetTransferList.vue?vue&type=template&id=760a141f", function () {
      api.rerender('760a141f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/fixed-asset/AssetTransferList.vue"
export default component.exports